import { Box } from "@material-ui/core";

export function FormFields({ children }) {
  return (
    <Box display="flex" flexDirection="column" gridGap="30px">
      {children}
    </Box>
  );
}

export function Field({ children }) {
  return (
    <Box display="flex" flexDirection="column" maxWidth="90%">
      {children}
    </Box>
  );
}
